import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Form,
  FormField,
  Grid,
  GridColumn,
  GridRow,
} from 'semantic-ui-react'
import Swal from 'sweetalert2'
import * as yup from 'yup'
import { setBatchDynamicAlarm } from '../../../../services/customer'
import { CustomerViewContext } from '../customer-info-view/customerView'
import styles from './customerSettings.module.css'

const commandBuilder = (threshold) => {
  const formula = (2 ** 7 + 2 ** 6 + threshold).toString(16)
  return `S0=04,S7=${formula},S8=00`
}

const formResolver = yup.object().shape({
  height: yup
    .number()
    .required('Height is required')
    .typeError('Invalid height'),
})

const successSwalContent = {
  title: "Height threshold is applied to all customer's devices",
  confirmButtonColor: 'Green',
  icon: 'success',
}
const failSwalContent = {
  title: 'Error: Unable to set Dynamic Alarm Level!',
  confirmButtonColor: 'Red',
  icon: 'error',
}

const CustomerDynamicAlertSettings = () => {
  const {
    customerSettings: { tbCustomerId },
  } = useContext(CustomerViewContext)

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(formResolver),
  })

  const batchAlarmLevel = localStorage.getItem('batchAlarmLevel')

  const formHandler = async ({ height }) => {
    Swal.showLoading()

    localStorage.setItem('batchAlarmLevel', height)

    const command = commandBuilder(height)
    const params = {
      customerId: tbCustomerId,
      heightThreshold: height,
      command,
    }
    try {
      const response = await setBatchDynamicAlarm(params)
      if (response.success) {
        Swal.fire(successSwalContent)
      } else throw new Error()
    } catch (error) {
      Swal.fire(failSwalContent)
    }
  }
  return (
    <Form
      style={{
        backgroundColor: 'rgb(216, 231, 234)',
        padding: 10,
        borderRadius: 9,
      }}
      id="dynamicAlertForm"
      onSubmit={handleSubmit(formHandler)}
    >
      <h3 className={styles.formHeader}>Dynamic Alarm Level</h3>
      <FormField>
        <Grid columns={3}>
          <GridRow>
            <GridColumn>
              <FormField>
                <span>Height Threshold (0.1 cm - 6.3 cm):</span>
                <input
                  name="height"
                  ref={register}
                  type="number"
                  min={0.1}
                  max={6.3}
                  step={0.1}
                  defaultValue={batchAlarmLevel || 5}
                  placeholder="Height"
                />
                <small style={{ color: 'red' }}>**</small>
                {errors.height && (
                  <p style={{ color: 'red' }}>{errors.height.message}</p>
                )}
              </FormField>
            </GridColumn>
          </GridRow>
        </Grid>
        <hr />
        <Grid>
          <Grid.Column textAlign="center">
            <Button
              from="dynamicAlertForm"
              type="submit"
              className={styles.Button}
              color="red"
            >
              Submit
            </Button>
          </Grid.Column>
        </Grid>
      </FormField>
    </Form>
  )
}

export default CustomerDynamicAlertSettings
